<template>
  <div class="updates container">
    <h3 class="text-center mt-3 mb-5 mx-3">更新履歴</h3>
    <table class="table text-left">
      <tbody>
        <tr>
          <td>2025/2/5</td>
          <td>
            プライバシーポリシーを制定
          </td>
        </tr>
        <tr>
          <td>2025/1/28</td>
          <td>
            URL失効によりcolour-field.jpに移転<br>
            大変申し訳ありませんでした
          </td>
        </tr>
        <tr>
          <td>2021/8/28</td>
          <td>三連符に対応</td>
        </tr>
        <tr>
          <td>2020/5/28</td>
          <td>正式版をリリース</td>
        </tr>
        <tr>
          <td>2020/6月～</td>
          <td>別サービスの開発により中断</td>
        </tr>
        <tr>
          <td>2019/5/19</td>
          <td>Beta版公開</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'updates'
}
</script>

<style scoped>
.updates{
  max-width: 600px;
}
</style>
